import DocStatsCard from "./DocStatsCard";
import totalDocuments from '../../../assets/icons/DocumentIcon.svg';
import handbooks from "../../../assets/icons/HandbookIcon.svg";
import presentations from "../../../assets/icons/PresentationIcon.svg";
import faq from "../../../assets/icons/FaqIcon.svg";
import installGuide from "../../../assets/icons/InstallGuideIcon.svg";
import knowledgeDoc from "../../../assets/icons/otherDocumentIcon.svg";
import DocumentBarChart from "./charts/DocumentBarChart";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../auth/AuthContext";
import { useCallback, useContext, useEffect, useState } from "react";
import DocumentService from "../../../services/DocumentService";
import AlertService from "../../../services/AlertService";

const DocumentDashboard = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true); 
  const DocumentAccess = authContext.getPermissions("documentdashboard");
  const showAdd = DocumentAccess.some(f => f.access.includes(2));

const loadDashboard = useCallback(async (signal) => { 
    setLoading(true);
    try {
      const response = await DocumentService.GetDashboard(
        authContext,
        signal 
      );

      if (signal?.aborted) return;

      if (response.isSuccess) {
        const data = [
          { title: "Total Documents", value: response.data.totalDocuments, pages: response.data.totalPages, icon: totalDocuments, bgColor: "#E3F0FF" },
          { title: "Handbooks",tagLabel: "HandBooks", value: response.data.handBooksCount, pages: response.data.handBooksPages, icon: handbooks, bgColor: "#E7E6FF" },
          { title: "Presentations",tagLabel: "Presentations", value: response.data.presentationsCount, pages: response.data.presentationsPages, icon: presentations, bgColor: "#C3E1FF" },
          { title: "FAQ-Bay", tagLabel: "FAQ-Cyber Range", value: response.data.faqCount, pages: response.data.faqPages, icon: faq, bgColor: "#FFE3F0" },
          { title: "Installation & Configuration Documents", tagLabel: "Install & Configuration Guide", value: response.data.installCount, pages: response.data.installPages, icon: installGuide, bgColor: "#E6FFF8" },
          { title: "Knowledge Documents", tagLabel: "Knowledge Document", value: response.data.knowledgeCount, pages: response.data.knowledgePages, icon: knowledgeDoc, bgColor: "#FFFBF5" },
        ];
        setCardData(data);
      } else {
        AlertService.error(
          response.errorMessage || "Failed to fetch dashboard data"
        );
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
      AlertService.error("Failed to fetch dashboard data");
      console.error(err);
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext]);

useEffect(() => {
    const controller = new AbortController();
    loadDashboard(controller.signal); 
    return () => controller.abort(); 
  }, [loadDashboard]);

  return (
    <div className="container-fluid mt-2 pb-3">
      <div className="d-flex justify-content-end gap-3 mb-3">
        <button
          className="btn btn-primary py-2 px-md-4"
          onClick={() => navigate('/document-dashboard/documents')}
        >
          View All
        </button>
         {showAdd && (
          <button
            className="btn btn-primary py-2 px-md-4"
            onClick={() => navigate('/document-dashboard/documents-mapping')}
          >
            Mapping
          </button>
         )}
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="row g-3 mb-4">
            {(loading ? Array.from({ length: 6 }) : cardData).map((card, idx) => (
              <DocStatsCard key={idx} {...card} loading={loading}
                  onClick={() => navigate('/document-dashboard/documents', { state: { tag: card.tagLabel } })}
                   />
            ))}
          </div>
        </div>
        <div className="col-xl-6">
          <DocumentBarChart loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default DocumentDashboard;
